import { InlineText2 } from '@cian/ui-kit';
import * as React from 'react';

export const NotFoundError = () => {
  return <InlineText2 color="current_color">Позиция не найдена</InlineText2>;
};
